export class Project {

	public apiModel: {} = {};

	constructor(public name: string, public apiUrl: string) {
	}

	setAPIModel(newAPIModel: {}) {
		this.apiModel = newAPIModel;
	}

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/components/core/model/project.ts
 **/